const initialState = {
  allWorksheetFolder: [],
  worksheet: null,
  worksheetId: null,
  loading: true,
  item: [],
  questions: [],
  singleWorksheetQuestions: [],
  current: null,
  questionId: null,
};

const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_CURRENT":
      return {
        ...state,
        current: action.data,
        loading: action.loading,
      };
    case "CLEAR_CURRENT":
      return {
        ...state,
        current: null,
        loading: action.loading,
      };
    case "GET_WORKSHEET_FOLDER":
      return {
        ...state,
        allWorksheetFolder: action.data,
        loading: action.loading,
      };
    case "GET_WORKSHEET":
      return {
        ...state,
        item: action.data,
        loading: action.loading,
      };
    case "GET_WORKSHEET_QUESTIONS":
      return {
        ...state,
        questions: action.data,
        loading: action.loading,
      };
    case "GET_SINGLE_WORKSHEET_QUESTIONS":
      return {
        ...state,
        singleWorksheetQuestions: action.data,
        loading: action.loading,
      };
    // GET_SINGLE_WORKSHEET_QUESTIONS
    case "UPDATE_THEME":
      return {
        ...state,
        allWorksheetFolder: action.data,
      };
    case "SET_QUESTION_ID":
      return {
        ...state,
        questionId: action.payload,
      };
    case "UPDATE":
      return {
        ...state,
        worksheet: action.data,
      };
    case "UPDATE_WORKSHEET_ID":
      return {
        ...state,
        worksheetId: action.data,
      };
    // UPDATE_WORKSHEET_ID
    case "ADD_PAPERS":
      return {
        ...state,
        worksheet: action.papers,
      };

    default:
      return state;
  }
};

export default categoryReducer;
